module.exports = __webpack_public_path__ + "static/media/Inter-Medium.453c114a.woff";